import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { removeToken } from "../../redux/tokenSlice";
import Loader from "../Loader";
import axios from "axios";
import { Box, ListItemIcon, Popover } from "@mui/material";
import { useDispatch } from "react-redux";
import { restrictedUser } from "../../utils";

function AyekartRetailLimitBreachedGridView() {
  const location = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [loading, setLoading] = useState(false);
  const [gridOrders, setGridOrders] = useState([]);
  const [markAsPaid, setMarkAsPaid] = useState(false);
  const [toGetUpdatedList, setTogetUpdatedList] = useState(false);
  const [status, setStatus] = useState("");
  const [allOrdersTotal, setAllOrdersTotal] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [statusArray, setStatusArray] = useState([]);
  const [formObj, setFormObj] = useState([]);
  const [selectedOrdersTotal, setSelectedOrdersTotal] = useState(0);
  const [downloadSheetFlag, setDownloadSheetFlag] = useState(false);
  const [gridComment, setGridComment] = useState([]);
  const [gridStatus, setGridStatus] = useState("");
  const [currentGridId, setCurrentGridId] = useState(location?.state?.id);
  const [gridPage, setGridPage] = useState(location?.state?.gridPage || 1);
  const [totalGrids] = useState(location?.state?.totalGrids || 0);
  const [activeTab] = useState(location?.state?.activeTab ?? 0);
  const [searchQuery] = useState(location?.state?.searchQuery || "");

  const gridId = currentGridId ?? location?.state?.id;
  const tabNames = [
    "excep_pending",
    "excep_approved",
    "excep_plus_normal_approved",
    "excep_payment_done",
    "excep_cancelled",
  ];

  const history = useNavigate();

  const resetGridViewState = () => {
    setMarkAsPaid(false);
    setSelectAll(false);
    setSelectedOrdersTotal(0);
    setDownloadSheetFlag(false);
  };

  const getTableData = () => {
    if (!gridId) return;
    const token = localStorage.getItem("token");
    setLoading(true);
    setDownloadSheetFlag(false);
    fetch(`/workflow/api/${gridId}/orders`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.grid_status === "Paid") {
          setDownloadSheetFlag(true);
        }
        let temp = [];
        let sum = 0;
        res?.orders.map((item, index) => {
          if (item?.grid_status === "Paid") {
            setDownloadSheetFlag(true);
          }
          sum = sum + Number(item?.amount_to_be_paid_net_off_tds);
          temp.push({
            order_id: item?.order_id,
            order_flag: item?.grid_status === "Paid" ? true : false,
          });
        });
        setStatusArray(temp);
        setAllOrdersTotal(sum);
        setGridOrders(res?.orders);
        setGridComment(res?.grid_comment || "");
        setGridStatus(res?.grid_status);

        setStatus(res?.grid_status);
        if (res?.grid_status === "Paid") {
          setSelectedOrdersTotal(sum);
        }
        setLoading(false);
      });
  };

  const fetchGridAtPage = async (targetPage) => {
    if (targetPage < 1 || (totalGrids > 0 && targetPage > totalGrids)) return;

    setLoading(true);
    const token = localStorage.getItem("token");
    const selectedTab = tabNames[activeTab] || "excep_pending";

    try {
      const response = await fetch(
        `/workflow/api/orders/grids?is_exceptional_grid=true&org_id=2&tab_name=${selectedTab}&page=${targetPage}&limit=1${
          searchQuery ? `&id=${searchQuery}` : ""
        }`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await response.json();

      if (data?.status && data?.grids?.length > 0) {
        const newGridId = data.grids[0].id;
        resetGridViewState();
        setCurrentGridId(newGridId);
        setGridPage(targetPage);
        history(location.pathname, {
          replace: true,
          state: {
            ...location.state,
            id: newGridId,
            gridPage: targetPage,
            activeTab,
            totalGrids,
            searchQuery,
          },
        });
      } else {
        toast.error("No grid found");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to fetch grid");
      setLoading(false);
    }
  };

  const handlePreviousGrid = () => {
    if (gridPage > 1) fetchGridAtPage(gridPage - 1);
  };

  const handleNextGrid = () => {
    if (totalGrids === 0 || gridPage < totalGrids) fetchGridAtPage(gridPage + 1);
  };

  useEffect(() => {
    getTableData();
  }, [toGetUpdatedList, currentGridId]);

  const submitMarkAsPaid = () => {
    let temp = statusArray;
    let tempArray = [];
    temp.map((item, index) => {
      if (item?.order_flag === true) {
        tempArray.push(item?.order_id);
      }
    });
    let finalTemp = [];
    gridOrders.map((item, index) => {
      if (tempArray.includes(item?.order_id)) {
        if (item?.grid_status !== "Paid") {
          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.total_cp,
            status: "Paid",
          });
        } else {
          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.total_cp,
            status: item?.grid_status,
          });
        }
      }
    });

    if (status === "Paid") {
      return toast.error("This grid has already added as Marked as Paid");
    }
    setLoading(true);
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const payload = {
      orders: finalTemp,
      grid_status:
        gridOrders?.length === tempArray?.length ? "Paid" : "Pending",
      actioner: userDetails?.user_name
        ? userDetails?.user_name
        : userDetails?.user_category,
    };
    axios
      .put(`/workflow/api/grid/${gridId}/paid`, payload, config)
      .then((data) => {
        if (data?.data?.status === false) {
          setLoading(false);
          toast.error(data?.data?.message);
        } else {
          setTogetUpdatedList(true);
          toast.success(data?.data?.message);
          setTimeout(function () {
            history("/ayekart-fintech/grids");
          }, 1000);
        }
      });
  };

  const cancelGrid = () => {
    if (window.confirm("Do you really want to cancel this Grid?")) {
       setLoading(true);
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const cancelGridOrders = gridOrders.map((item) => ({
        id: item?.order_id,
        amount_paid: item?.amount_paid,
        total_cp: item?.total_payable_net_off_tds,
      }));
      const payload = {
        orders: cancelGridOrders,
        grid_status: "Rejected",
        rejection_stamp: `${new Date()?.toISOString()}`,
        actioner: userDetails?.user_name
          ? userDetails?.user_name
          : userDetails?.user_category,
        actioner_id: userDetails?.id ? userDetails?.id : userDetails?.id,
      };
      axios
        .put(`/workflow/api/grid/${gridId}/paid`, payload, config)
        .then((data) => {
          if (data?.data?.status === false) {
            setLoading(false);
            toast.error(data?.data?.message);
          } else {
            toast.success("Grid has been cancelled");
            setTimeout(function () {
              history("/ayekart-retail/limit-breached-grids", {
                state: { activeTab: 4 },
              });
            }, 1000);
            
          }
        });
    }
  };

  const getCSVForSBI = () => {
    // setLoading(true);
    // fetch(`/workflow/api/${location?.state?.id}/finance?bank=sbi`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     setGridOrders(res?.orders);
    //     setLoading(false);
    //   });
    return toast.error("No records found to download...");
  };

  const getCSVForIcici = () => {
    setLoading(true);
    fetch(`/workflow/api/${gridId}/finance?bank=icici`)
      .then((res) => res.json())
      .then((res) => {
        setGridOrders(res?.orders);
        setLoading(false);
      });
  };

  const getCSVForAxis = () => {
    setLoading(true);
    fetch(`/workflow/api/${gridId}/finance?bank=sbi`)
      .then((res) => res.json())
      .then((res) => {
        setGridOrders(res?.orders);
        setLoading(false);
      });
  };

  return (
    <div className="flex">
      <div className="mt-0 ml-8 builk-main ">
        <Loader loading={loading} />
        <div className="p-3">
          <div className="mt-2 pb-5"></div>
          <div className="container-fluid">
            <div className="row ">
              <div className="col-2">
                <button
                  type=""
                  className="btn btn-primary w-100 finance-grid-view-bg-4b589c"
                  onClick={() =>
                    history("/ayekart-retail/limit-breached-grids", {
                      state: { activeTab: location?.state?.activeTab },
                    })
                  }
                >
                  <i className="fa fa-arrow-left mr-1" aria-hidden="true"></i>
                  Back to Grids
                </button>
              </div>
            </div>
          </div>
          <div className="container-fluid mt-4 p-0">
            <div className="row mx-0">
              <div className="col col-sm-12 col-md-12 col-lg-2 border pt-3">
                <div className="row">
                  <span className="">
                    <h5 className="fw-bold">Total CP(₹)</h5>
                  </span>
                  <h5>₹ {Number(allOrdersTotal).toFixed(2)} </h5>
                </div>
                <div className="row border-top pt-2 mt-2"></div>
              </div>
              <div className="col col-sm-12 col-md-12 col-lg-10 p-2 border">
                <div className="container-fluid text-center mt-2 rounded shadow">
                  <div className="row gy-3 d-flex mx-0 justify-content-end mt-2 pb-2">
                    <div className="col d-flex align-items-center gap-2 flex-wrap">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handlePreviousGrid}
                        disabled={gridPage <= 1 || loading}
                      >
                        Previous Grid
                      </button>
                      <h4 className="mb-0">Grid No. {gridId} Orders</h4>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handleNextGrid}
                        disabled={
                          loading || (totalGrids > 0 && gridPage >= totalGrids)
                        }
                      >
                        Next Grid
                      </button>
                      {totalGrids > 0 && (
                        <span className="text-muted small">
                          ({gridPage} of {totalGrids})
                        </span>
                      )}
                    </div>
                    <div className="col-12 pl-0">
                    <div className="mt-3 d-flex flex-column justify-content-start align-items-start p-2">
                      <label className="form-label fw-bold">Grid Comment</label>
                      <div className="p-2 border rounded bg-light w-100">
                        {gridComment || "Grid Comment Not Available"}
                      </div>
                    </div>
                    </div>
                  </div>
                  <div className="row finance-grid-table-head">
                    <div className="col col-sm-1 col-md-1 col-lg-1 pt-2 finance-grid-bg-adb2da d-flex">
                      <span className="w-25"></span>
                      <h5>Order ID</h5>
                    </div>
                    <div className="col col-sm-3 col-md-3 col-lg-3 pt-2 finance-grid-bg-adb2da">
                      <h5>Supplier Shop Name</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>Total CP(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>Total payable(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5>TDS(₹)</h5>
                    </div>
                    <div className="col col-sm-2 col-md-2 col-lg-2 pt-2 finance-grid-bg-adb2da">
                      <h5> Amount To Be Paid Net Off TDS(₹)</h5>
                    </div>
                  </div>
                  <div className="row mt-2 finance-grid-tbody">
                    <div className="container-fluid ">
                      {gridOrders?.length > 0 ? (
                        gridOrders?.map((item, index) => (
                          <React.Fragment key={index}>
                            <div className="row mb-2">
                              <div className="col col-sm-1 col-md-1 col-lg-1 pt-3 pb-2 finance-grid-bg-bec3ee d-flex">
                                <span className="w-25"></span>
                                <h6 className=" mt-1">{item?.order_id}</h6>
                              </div>
                              <div className="col col-sm-3 col-md-3 col-lg-3 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <h6 className=" mt-1">
                                  {item?.supplier_shop_name}
                                </h6>
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  className="form-control"
                                  type="text"
                                  readOnly
                                  name=""
                                  value={item?.total_payable_net_off_tds}
                                />
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  readOnly
                                  className="form-control"
                                  type="text"
                                  name=""
                                  value={item?.total_payable}
                                  placeholder="TDS"
                                />
                              </div>
                              <div className="col col-sm-2 col-md-2 col-lg-2 pt-3 pb-2 finance-grid-bg-bec3ee">
                                <input
                                  readOnly
                                  className="form-control"
                                  type="text"
                                  name=""
                                  value={item?.tds}
                                  placeholder="Total Amount"
                                />
                              </div>
                              <div className="col   col-sm-2 col-md-2 col-lg-2 pt-3 finance-grid-bg-bec3ee">
                                <h6>{item?.amount_to_be_paid_net_off_tds}</h6>
                              </div>
                            </div>
                          </React.Fragment>
                        ))
                      ) : (
                        <>
                          <div className="row mt-2 finance-grid-tbody-no-data">
                            <p>No Data Added</p>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {/* Cancel Grid */}
            {gridStatus !== "Rejected" && gridStatus !== "Paid" && (
              <button
                type="button"
                className="btn btn-danger px-3 mt-2"
                onClick={cancelGrid}
                disabled={restrictedUser()}
              >
                Cancel Grid
              </button>
            )}
              </div>
            </div>
          </div>
        </div>
        <Toaster />
      </div>
    </div>
  );
}

export default AyekartRetailLimitBreachedGridView;
